{"id":"ProductDetail.Gallery.MainImage","prefabs":{"default":{"children":[{"component":"ProductDetail.Gallery.MainImage","options":"options:*"}]}}}